import { Extension } from "@terra-money/terra.js";

const Account = ({ extension }, args = {}) => {
  const getAddress = async () => {
    return new Promise((resolve) => {
      extension.connect();
      extension.on("onConnect", ({ address }) => {
        resolve({ address });
      });
    });
  };
  const signTransaction = async (rawTx) => {
    const options = {
      msgs: rawTx.msgs.map((msg) => JSON.stringify(msg)),
      fee: JSON.stringify(rawTx.fee),
      memo: rawTx.memo,
      account_number: rawTx.account_number,
      sequence: rawTx.sequence,
    };
    return new Promise((resolve, reject) => {
      extension.send("post", options);
      extension.on("onPost", (data) => {
        if (!data.success) {
          return reject(new Error("User denied transaction."));
        }
        resolve({
          txHash: data.result.txhash,
        });
      });
    });
  };

  return {
    getAddress,
    signTransaction,
  };
};

const Backend = ({ extension }) => {
  const genAccount = async (args) => Account({ extension }, args);

  const getAccount = async (args) => genAccount(args);

  const cleanUp = async () => {};

  return {
    getAccount,
    cleanUp,
  };
};

Backend.create = async ({ terrastationOptions = {} } = {}) => {
  if (!window.isTerraExtensionAvailable) {
    throw new Error("Terra station is not installed.");
  }
  const extension = new Extension();
  extension.connect();
  return Backend({ extension });
};

export default Backend;
